import React, { useEffect, useMemo, useRef, useState } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { Button, Col, Row } from 'react-bootstrap';
import Select from 'react-select';
import axios from 'axios';
import swal from 'sweetalert';
import LoadingOverlay from 'react-loading-overlay-ts';
import { useReactToPrint } from 'react-to-print';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import '../../Filters/Common/filtering.css';
import ERROR from '../../../components/Validation/ErrorMessage';
import COMMON_API from '../../../Api/CommonApi';
import DEBIT_NOTE_API from '../../../Api/DebitNoteApi';
import COMMONVARIABLES from '../../Utilities/constants';
import Formatting from '../../Utilities/format';
import { useDispatch } from 'react-redux';
import { getLoggedInUser, getRefreshToken } from '../../../../services/AuthService';
import { Logout, navtoggle } from '../../../../store/actions/AuthActions';
import Logo from '../../../../pictures/bw1.png';

const selectTheme = (theme) => ({
	...theme,
	borderRadius: '6px',
	colors: {
		...theme.colors,
		primary25: '#b3b3b3',
		primary: 'black',
		neutral80: 'data-theme-version' === 'dark' ? 'white' : '',
	},
});

export const DebitNoteAdd = () => {
	const paramData = useLocation();
	const navigate = useNavigate();
	const dispatch = useDispatch();
	const BASE_URL = process.env.REACT_APP_BASE_URL;
	const buttonRef = useRef(null);
	const SUPPLIERTYPE = COMMONVARIABLES.SUPPLIERTYPE;

	const [title, setTitle] = useState('Add Debit Note');
	const [btnTitle, setBtnTitle] = useState('Save');
	const [transNo, setTransNo] = useState(0);
	const [isLoading, setIsLoading] = useState(false);
	const [buttonFlag, setButtonFlag] = useState(false);

	const [debitNoteNo, setDebitNoteNo] = useState('');
	const [debitNoteDate, setDebitNoteDate] = useState(new Date().toISOString().slice(0, 10));
	const [narration, setNarration] = useState('');

	const [supplierList, setSupplierList] = useState([]);
	const [supplierNameOptions, setSupplierNameOptions] = useState([]);
	const [supplierType, setSupplierType] = useState({ label: 'Registered', value: 1 });
	const [supplierName, setSupplierName] = useState({});
	const [supplierAddress, setSupplierAddress] = useState('');
	const [supplierCity, setSupplierCity] = useState('');
	const [supplierContact, setSupplierContact] = useState('');
	const [supplierGstin, setSupplierGstin] = useState('');

	const [itemOptions, setItemOptions] = useState([]);
	const [itemDetails, setItemDetails] = useState([]);
	const [isEdit, setIsEdit] = useState(0);
	const [currentSno, setCurrentSno] = useState(0);

	const [currentItem, setCurrentItem] = useState(null);
	const [currentQty, setCurrentQty] = useState('');
	const [currentRate, setCurrentRate] = useState('');
	const [currentAmount, setCurrentAmount] = useState(0);

	const contentToPrint = useRef(null);
	const [isPrint, setIsPrint] = useState(0);
	const [localUserDetails, setLocalUserDetails] = useState(null);
	const [printData, setPrintData] = useState({
		debit_note_no: '',
		debit_note_date: '',
		supplier_name: '',
		supplier_address: '',
		supplier_city: '',
		supplier_gstin: '',
		supplier_contact: '',
		narration: '',
		total_amount: 0,
		item_details: [],
	});

	useEffect(() => {
		dispatch(navtoggle()); // close side menu like Purchase Add
		const lcluserDetails = localStorage.getItem('userDetails');
		if (lcluserDetails) {
			setLocalUserDetails(JSON.parse(lcluserDetails));
		}
		fetchMasterData();
	}, []); // eslint-disable-line react-hooks/exhaustive-deps

	useEffect(() => {
		if (isPrint === 1) {
			handlePrint(null, () => contentToPrint.current);
			setIsPrint(0);
		}
	}, [printData, isPrint]); // eslint-disable-line react-hooks/exhaustive-deps

	const handlePrint = useReactToPrint({
		documentTitle: 'Debit Note',
		onAfterPrint: () => {
			navigate('/debit-note-list');
		},
		removeAfterPrint: true,
	});

	useEffect(() => {
		const editId = Number(paramData?.state?.debit_note_id || paramData?.state?.transNo || 0);
		if (editId > 0 && supplierList.length > 0 && itemOptions.length > 0 && Number(transNo) !== editId) {
			setTransNo(editId);
			setTitle('Update Debit Note');
			setBtnTitle('Update');
			editLoadData(editId);
		}
	}, [supplierList, itemOptions, paramData?.state]); // eslint-disable-line react-hooks/exhaustive-deps

	useEffect(() => {
		if (!supplierName?.value) {
			setSupplierAddress('');
			setSupplierCity('');
			setSupplierContact('');
			setSupplierGstin('');
			return;
		}
		const supplier = supplierList.find((e) => e?.sm_supplier_code === supplierName?.value);
		if (supplier) {
			setSupplierAddress(supplier?.sm_address || '');
			setSupplierCity(supplier?.sm_city || '');
			setSupplierContact(supplier?.sm_mobile_number || '');
			setSupplierGstin(supplier?.sm_gstin || '');
		}
	}, [supplierName, supplierList]);

	useEffect(() => {
		const qty = Number(currentQty) || 0;
		const rate = Number(currentRate) || 0;
		setCurrentAmount(Formatting('two_decimal', qty * rate));
	}, [currentQty, currentRate]);

	const totalAmount = useMemo(() => {
		return Formatting(
			'two_decimal',
			itemDetails.reduce((sum, row) => sum + (Number(row.amount) || 0), 0)
		);
	}, [itemDetails]);

	async function handleUnauthorized(retryFn) {
		const refresh = await getRefreshToken();
		if (refresh) {
			if (Number(refresh) === COMMONVARIABLES.STATUS.EXPIRED_TOKEN) {
				Logout();
			} else {
				await retryFn();
			}
		}
	}

	const onChangeSupplierType = (event) => {
		setSupplierType(event);
		const supplier_array = supplierList.filter((e) => e.supplier_type === event?.value);
		setSupplierNameOptions(supplier_array || []);
		setSupplierName({});
	};

	async function fetchMasterData() {
		try {
			setIsLoading(true);
			const user = getLoggedInUser();
			const localFy = localStorage.getItem('fy');
			const listParams = { status_code: 1, user_id: user?.id };
			const debitNoParams = { fy: localFy ? Number(localFy) : 0, user_id: user?.id };
			const config = { headers: { authorization: 'Bearer '.concat(user.accessToken) } };

			const [supplierData, itemData, debitNoData] = await Promise.all([
				axios.post(BASE_URL + COMMON_API.SUPPLIER_MASTER_LIST, listParams, config),
				axios.post(BASE_URL + COMMON_API.ITEM_MASTER_LIST, listParams, config),
				axios.post(BASE_URL + DEBIT_NOTE_API.DEBIT_NOTE_NO, debitNoParams, config).catch(() => null),
			]);

			if (
				supplierData?.data?.body?.status === COMMONVARIABLES.STATUS.UNAUTHORIZED ||
				itemData?.data?.body?.status === COMMONVARIABLES.STATUS.UNAUTHORIZED ||
				debitNoData?.data?.body?.status === COMMONVARIABLES.STATUS.UNAUTHORIZED
			) {
				await handleUnauthorized(fetchMasterData);
				setIsLoading(false);
				return;
			}

			if (
				supplierData?.data?.body?.status === COMMONVARIABLES.STATUS.SERVICE_CATCH_STATUS ||
				itemData?.data?.body?.status === COMMONVARIABLES.STATUS.SERVICE_CATCH_STATUS
			) {
				toast.error(ERROR.API_ERROR.SERVICE_CATCH_ERROR, { position: toast.POSITION.TOP_RIGHT });
			}

			if (supplierData?.data?.body?.supplierList) {
				const allSuppliers = supplierData.data.body.supplierList;
				setSupplierList(allSuppliers);
				const supplier_array = allSuppliers.filter((e) => e.supplier_type === supplierType?.value);
				setSupplierNameOptions(supplier_array || []);
			}
			if (itemData?.data?.body?.itemList) {
				setItemOptions(itemData.data.body.itemList);
			}
			// Max No API: { status: 200, body: { debit_note_number, debit_note_date } }
			// Use number only; keep Debit Date as current local date (API ISO date shifts to previous day in IST)
			const maxBody = debitNoData?.data?.body || {};
			const maxStatus = debitNoData?.data?.status ?? maxBody.status;
			if (
				maxStatus === COMMONVARIABLES.STATUS.SUCCESS ||
				maxBody.debit_note_number != null ||
				maxBody.debit_note_no != null
			) {
				const maxNo = maxBody.debit_note_number ?? maxBody.debit_note_no ?? maxBody.max_no ?? '';
				if (maxNo !== '' && maxNo != null) {
					setDebitNoteNo(String(maxNo));
				}
			}
			if (Number(transNo) === 0) {
				const today = new Date();
				const y = today.getFullYear();
				const m = String(today.getMonth() + 1).padStart(2, '0');
				const d = String(today.getDate()).padStart(2, '0');
				setDebitNoteDate(`${y}-${m}-${d}`);
			}
			setIsLoading(false);
		} catch (error) {
			setIsLoading(false);
			console.error('Error fetching debit note master data:', error);
			if (error.code === COMMONVARIABLES.STATUS.NETWORK_ERROR_STATUS) {
				toast.error(ERROR.API_ERROR.NETWORK_ERROR, { position: toast.POSITION.TOP_RIGHT });
			}
			if (error.code === COMMONVARIABLES.STATUS.BAD_REQUEST_ERROR_STATUS) {
				toast.error(ERROR.API_ERROR.BAD_REQUEST_ERROR, { position: toast.POSITION.TOP_RIGHT });
			}
		}
	}

	async function editLoadData(transactionNo) {
		try {
			setIsLoading(true);
			const user = getLoggedInUser();
			const config = { headers: { authorization: 'Bearer '.concat(user.accessToken) } };
			const editLoadDataRes = await axios.post(
				BASE_URL + DEBIT_NOTE_API.EDIT_DEBIT_NOTE,
				{
					user_id: Number(user?.id),
					debit_note_id: Number(transactionNo),
				},
				config
			);

			const resStatus = editLoadDataRes?.data?.body?.status ?? editLoadDataRes?.data?.status;
			if (resStatus === COMMONVARIABLES.STATUS.UNAUTHORIZED) {
				setIsLoading(false);
				await handleUnauthorized(() => editLoadData(transactionNo));
				return;
			}

			if (resStatus === COMMONVARIABLES.STATUS.SERVICE_CATCH_STATUS) {
				toast.error(ERROR.API_ERROR.SERVICE_CATCH_ERROR, { position: toast.POSITION.TOP_RIGHT });
				setIsLoading(false);
				return;
			}

			const body = editLoadDataRes?.data?.body || {};
			// Edit load: debitNoteList[0] = header, debitNoteItemList = items
			const headerList = body.debitNoteList || [];
			const header = Array.isArray(headerList) && headerList.length > 0 ? headerList[0] : null;
			const details = Array.isArray(body.debitNoteItemList) ? body.debitNoteItemList : [];

			if (header) {
				setTransNo(Number(header.dn_debit_note_id || transactionNo));

				const noteNo = header.dn_debit_note_number;
				if (noteNo != null && noteNo !== '') {
					setDebitNoteNo(String(noteNo));
				}

				const rawDate = header.dn_debit_note_date;
				if (rawDate) {
					const dateStr = String(rawDate);
					if (/^\d{4}-\d{2}-\d{2}/.test(dateStr)) {
						setDebitNoteDate(dateStr.slice(0, 10));
					} else if (dateStr.includes('/')) {
						const parts = dateStr.split('/');
						if (parts.length === 3) {
							setDebitNoteDate(
								`${parts[2]}-${parts[1].padStart(2, '0')}-${parts[0].padStart(2, '0')}`
							);
						}
					} else {
						const apiDate = new Date(rawDate);
						if (!Number.isNaN(apiDate.getTime())) {
							const y = apiDate.getFullYear();
							const m = String(apiDate.getMonth() + 1).padStart(2, '0');
							const d = String(apiDate.getDate()).padStart(2, '0');
							setDebitNoteDate(`${y}-${m}-${d}`);
						}
					}
				}

				const supplierId = header.dn_supplier_id;
				const supplier = supplierList.find(
					(e) => Number(e?.sm_supplier_code) === Number(supplierId)
				);
				if (supplier) {
					const typeJson = SUPPLIERTYPE.find((e) => e?.value === supplier?.supplier_type);
					if (typeJson) {
						setSupplierType(typeJson);
						const supplier_array = supplierList.filter((e) => e.supplier_type === typeJson.value);
						setSupplierNameOptions(supplier_array || []);
					}
					setSupplierName({
						label: supplier.sm_supplier_name,
						value: supplier.sm_supplier_code,
						supplier_type: supplier.supplier_type,
					});
				} else if (supplierId) {
					setSupplierName({
						label: String(supplierId),
						value: Number(supplierId),
					});
				}

				setNarration(header.dn_narration || header.narration || '');
			}

			if (details.length > 0) {
				const mergedByItemRate = [];
				details.forEach((item) => {
					const itemId = Number(item.item_id);
					const masterItem = itemOptions.find(
						(opt) => Number(opt.im_item_code) === itemId
					);
					const qty = Number(item.quantity || 0);
					const rate = Number(item.rate || 0);
					const existing = mergedByItemRate.find(
						(row) =>
							Number(row.item_id) === itemId && Number(row.rate) === rate
					);
					if (existing) {
						existing.qty = Number(existing.qty) + qty;
						existing.amount = Formatting(
							'two_decimal',
							Number(existing.qty) * rate
						);
						return;
					}
					mergedByItemRate.push({
						sno: mergedByItemRate.length + 1,
						item_id: itemId,
						item_code: itemId,
						item_name:
							item.item_name ||
							item.im_item_name ||
							masterItem?.im_display_name ||
							masterItem?.im_item_name ||
							'',
						qty,
						rate,
						amount: Formatting('two_decimal', qty * rate),
					});
				});
				setItemDetails(
					mergedByItemRate.map((row, index) => ({ ...row, sno: index + 1 }))
				);
			} else {
				setItemDetails([]);
			}
			setIsLoading(false);
		} catch (error) {
			setIsLoading(false);
			console.error('Error loading debit note:', error);
			if (error.code === COMMONVARIABLES.STATUS.NETWORK_ERROR_STATUS) {
				toast.error(ERROR.API_ERROR.NETWORK_ERROR, { position: toast.POSITION.TOP_RIGHT });
			}
			if (error.code === COMMONVARIABLES.STATUS.BAD_REQUEST_ERROR_STATUS) {
				toast.error(ERROR.API_ERROR.BAD_REQUEST_ERROR, { position: toast.POSITION.TOP_RIGHT });
			}
		}
	}

	const clearItemValues = () => {
		setCurrentItem(null);
		setCurrentQty('');
		setCurrentRate('');
		setCurrentAmount(0);
		setIsEdit(0);
		setCurrentSno(0);
	};

	const udfnAddItem = (e) => {
		e?.preventDefault?.();
		let error = '';

		if (!currentItem?.value) {
			error = ERROR.COMMON_REQUIRED;
		} else if (currentQty === '' || Number(currentQty) <= 0) {
			error = ERROR.DEBIT_NOTE.ITEM_QTY_VALID;
		} else if (currentRate === '' || Number(currentRate) < 0) {
			error = ERROR.DEBIT_NOTE.ITEM_RATE_VALID;
		}

		if (error) {
			toast.error(error, { position: 'top-right', autoClose: 5000 });
			return;
		}

		const itemId = Number(currentItem.value);
		const qtyToAdd = Number(currentQty);
		const rateValue = Number(currentRate);

		const isSameItemRate = (row) =>
			Number(row.item_id || row.item_code) === itemId &&
			Number(row.rate) === rateValue;

		const renumber = (list) =>
			list.map((row, index) => ({ ...row, sno: index + 1 }));

		// Edit: drop the row being edited first, then merge qty into same item+rate (or insert).
		// Add: merge qty into existing same item+rate, else append.
		setItemDetails((prev) => {
			const baseList =
				isEdit === 1 ? prev.filter((row) => row.sno !== currentSno) : prev;
			const existingIndex = baseList.findIndex(isSameItemRate);

			if (existingIndex > -1) {
				return renumber(
					baseList.map((row, index) => {
						if (index !== existingIndex) return row;
						const newQty = Number(row.qty) + qtyToAdd;
						return {
							...row,
							qty: newQty,
							amount: Formatting('two_decimal', newQty * rateValue),
						};
					})
				);
			}

			return renumber([
				...baseList,
				{
					sno: baseList.length + 1,
					item_id: itemId,
					item_code: currentItem.value,
					item_name: currentItem.label,
					qty: qtyToAdd,
					rate: rateValue,
					amount: Formatting('two_decimal', qtyToAdd * rateValue),
				},
			]);
		});
		clearItemValues();
	};

	const udfnLoadItem = (e, editItem, type) => {
		e?.preventDefault?.();
		setIsEdit(type);
		setCurrentSno(editItem?.sno);
		setCurrentItem({
			label: editItem?.item_name,
			value: editItem?.item_id || editItem?.item_code,
		});
		setCurrentQty(editItem?.qty);
		setCurrentRate(editItem?.rate);
		setCurrentAmount(editItem?.amount);
	};

	const udfnDeleteItem = (sno) => {
		const updated = itemDetails
			.filter((item) => item.sno !== sno)
			.map((item, index) => ({ ...item, sno: index + 1 }));
		setItemDetails(updated);
		if (currentSno === sno) {
			clearItemValues();
		}
	};

	const udfnResetForm = () => {
		setSupplierName({});
		setSupplierAddress('');
		setSupplierCity('');
		setSupplierContact('');
		setSupplierGstin('');
		setNarration('');
		setItemDetails([]);
		clearItemValues();
		if (transNo === 0) {
			setDebitNoteDate(new Date().toISOString().slice(0, 10));
			fetchMasterData();
		}
	};

	const validateForm = () => {
		if (!supplierName?.value || !debitNoteDate) {
			return ERROR.COMMON_REQUIRED;
		}
		if (itemDetails.length < 1) {
			return ERROR.DEBIT_NOTE.ITEM_DETAILS_VALID;
		}
		return '';
	};

	const buildItemPayload = () =>
		itemDetails.map((row) => ({
			item_id: Number(row.item_id || row.item_code),
			quantity: Number(row.qty),
			rate: Number(row.rate),
			amount: Number(row.amount),
		}));

	const buildDebitNotePayload = (isUpdate = false) => {
		const user = getLoggedInUser();
		const localFy = localStorage.getItem('fy');
		// Save / Update contract
		const params = {
			debit_note_date: debitNoteDate,
			supplier_id: Number(supplierName?.value),
			total_amount: Number(totalAmount),
			narration: narration || '',
			user_id: Number(user?.id),
			company_code: Number(user?.company_code),
			fy: Number(localFy),
			item_details: buildItemPayload(),
		};
		if (isUpdate) {
			params.debit_note_id = Number(transNo);
		}
		return params;
	};

	const onClickSaveBtn = async (event) => {
		if (transNo === 0) {
			await udfnSaveDebitNote(event);
		} else {
			await udfnUpdateDebitNote(event);
		}
	};

	const formatPrintDate = (rawDate) => {
		// Display as DD/MM/YYYY
		if (!rawDate) return '';
		const dateStr = String(rawDate).trim();
		if (dateStr.includes('/')) {
			const parts = dateStr.split('/');
			if (parts.length === 3) {
				const d = parts[0].padStart(2, '0');
				const m = parts[1].padStart(2, '0');
				const y = parts[2];
				return `${d}/${m}/${y}`;
			}
			return dateStr;
		}
		if (/^\d{4}-\d{2}-\d{2}/.test(dateStr)) {
			const [y, m, d] = dateStr.slice(0, 10).split('-');
			return `${d}/${m}/${y}`;
		}
		const apiDate = new Date(rawDate);
		if (!Number.isNaN(apiDate.getTime())) {
			const y = apiDate.getFullYear();
			const m = String(apiDate.getMonth() + 1).padStart(2, '0');
			const d = String(apiDate.getDate()).padStart(2, '0');
			return `${d}/${m}/${y}`;
		}
		return dateStr;
	};

	const mapPrintApiToPrintData = (body) => {
		const headerList = body?.debitNoteList || [];
		const header = Array.isArray(headerList) && headerList.length > 0 ? headerList[0] : null;
		const items = Array.isArray(body?.debitNoteItemList) ? body.debitNoteItemList : [];

		if (!header) {
			return null;
		}

		return {
			debit_note_id: header.dn_debit_note_id || 0,
			debit_note_no: header.dn_debit_note_number ?? '',
			debit_note_date: formatPrintDate(header.dn_debit_note_date),
			supplier_name: header.sm_supplier_name || '',
			supplier_address: header.sm_address || '',
			supplier_city: header.sm_city || '',
			supplier_gstin: header.sm_gstin || '',
			supplier_contact: header.sm_mobile_number || '',
			narration: header.dn_narration || header.narration || '',
			total_amount: Number(header.dn_total_amount ?? 0) || 0,
			item_details: items.map((item) => ({
				item_name: item.item_name || item.im_item_name || '',
				quantity: Number(item.quantity || 0),
				rate: Number(item.rate || 0),
				amount: Number(item.amount || 0),
			})),
		};
	};

	const fetchPrintData = async (debitNoteId) => {
		const user = getLoggedInUser();
		const config = { headers: { authorization: 'Bearer '.concat(user.accessToken) } };
		const printRes = await axios.post(
			BASE_URL + DEBIT_NOTE_API.PRINT_DEBIT_NOTE,
			{
				user_id: Number(user?.id),
				debit_note_id: Number(debitNoteId),
			},
			config
		);

		const status = printRes?.data?.body?.status ?? printRes?.data?.status;
		if (status === COMMONVARIABLES.STATUS.UNAUTHORIZED) {
			await handleUnauthorized(() => fetchPrintData(debitNoteId));
			return null;
		}
		if (status === COMMONVARIABLES.STATUS.SERVICE_CATCH_STATUS) {
			throw new Error(ERROR.API_ERROR.SERVICE_CATCH_ERROR);
		}

		const body = printRes?.data?.body;
		const mapped = mapPrintApiToPrintData(body);
		if (!mapped) {
			throw new Error('Print data not found');
		}
		return mapped;
	};

	const runPrintFlow = async (savedId) => {
		try {
			setIsLoading(true);
			const data = await fetchPrintData(savedId || 0);
			setIsLoading(false);
			if (!data) {
				navigate('/debit-note-list');
				return;
			}
			setPrintData(data);
			setIsPrint(1);
		} catch (e) {
			setIsLoading(false);
			console.error('Debit note print API error', e);
			toast.error(
				e?.message || ERROR.API_ERROR.SERVICE_CATCH_ERROR,
				{ position: toast.POSITION.TOP_RIGHT }
			);
			navigate('/debit-note-list');
		}
	};

	const askPrintConfirmation = (savedId, successText) => {
		// Popup 1: Success only
		swal({
			title: 'Success',
			text: successText,
			icon: 'success',
			button: 'OK',
			dangerMode: false,
		}).then(() => {
			// Popup 2: Print confirmation (separate)
			swal({
				title: 'Print Debit Note',
				text: 'Do you want to print the Debit Note invoice?',
				icon: 'warning',
				buttons: ['No', 'Yes'],
				dangerMode: false,
			}).then(async (willPrint) => {
				if (willPrint) {
					await runPrintFlow(savedId);
				} else {
					navigate('/debit-note-list');
				}
			});
		});
	};

	const udfnSaveDebitNote = async (event) => {
		try {
			event?.preventDefault?.();
			const error = validateForm();
			if (error) {
				toast.error(error, { position: 'top-right', autoClose: 5000 });
				return;
			}

			setButtonFlag(true);
			const params = buildDebitNotePayload(false);
			const user = getLoggedInUser();
			const config = { headers: { authorization: 'Bearer '.concat(user.accessToken) } };
			const saveData = await axios.post(BASE_URL + DEBIT_NOTE_API.SAVE_DEBIT_NOTE, params, config);
			setButtonFlag(false);

			const status = saveData?.data?.body?.status ?? saveData?.data?.status;
			if (status === COMMONVARIABLES.STATUS.UNAUTHORIZED) {
				await handleUnauthorized(() => udfnSaveDebitNote());
				return;
			}
			if (status === COMMONVARIABLES.STATUS.SERVICE_CATCH_STATUS) {
				toast.error(ERROR.API_ERROR.SERVICE_CATCH_ERROR, { position: toast.POSITION.TOP_RIGHT });
				return;
			}
			if (status === COMMONVARIABLES.STATUS.SUCCESS) {
				const savedId =
					saveData?.data?.body?.debit_note_id ||
					saveData?.data?.body?.dn_debit_note_id ||
					0;
				// Save (Add): success then print — no print confirmation
				swal({
					title: 'Success',
					text: 'Debit note saved successfully',
					icon: 'success',
					button: 'OK',
					dangerMode: false,
				}).then(async () => {
					await runPrintFlow(savedId);
				});
			} else if (saveData?.data?.body?.message) {
				toast.error(saveData.data.body.message, { position: toast.POSITION.TOP_RIGHT });
			}
		} catch (e) {
			setButtonFlag(false);
			if (e.code === COMMONVARIABLES.STATUS.NETWORK_ERROR_STATUS) {
				toast.error(ERROR.API_ERROR.NETWORK_ERROR, { position: toast.POSITION.TOP_RIGHT });
			} else if (e.code === COMMONVARIABLES.STATUS.BAD_REQUEST_ERROR_STATUS) {
				toast.error(ERROR.API_ERROR.BAD_REQUEST_ERROR, { position: toast.POSITION.TOP_RIGHT });
			} else {
				toast.error(ERROR.API_ERROR.SERVICE_CATCH_ERROR, { position: toast.POSITION.TOP_RIGHT });
			}
		}
	};

	const udfnUpdateDebitNote = async (event) => {
		try {
			event?.preventDefault?.();
			const error = validateForm();
			if (error) {
				toast.error(error, { position: 'top-right', autoClose: 5000 });
				return;
			}

			setButtonFlag(true);
			const params = buildDebitNotePayload(true);
			const user = getLoggedInUser();
			const config = { headers: { authorization: 'Bearer '.concat(user.accessToken) } };
			const updateData = await axios.post(BASE_URL + DEBIT_NOTE_API.UPDATE_DEBIT_NOTE, params, config);
			setButtonFlag(false);

			const status = updateData?.data?.body?.status ?? updateData?.data?.status;
			if (status === COMMONVARIABLES.STATUS.UNAUTHORIZED) {
				await handleUnauthorized(() => udfnUpdateDebitNote());
				return;
			}
			if (status === COMMONVARIABLES.STATUS.SERVICE_CATCH_STATUS) {
				toast.error(ERROR.API_ERROR.SERVICE_CATCH_ERROR, { position: toast.POSITION.TOP_RIGHT });
				return;
			}
			if (status === COMMONVARIABLES.STATUS.SUCCESS) {
				const savedId =
					updateData?.data?.body?.debit_note_id ||
					updateData?.data?.body?.dn_debit_note_id ||
					transNo;
				// Update: success popup, then separate print confirmation
				askPrintConfirmation(savedId, 'Debit note updated successfully');
			} else if (updateData?.data?.body?.message) {
				toast.error(updateData.data.body.message, { position: toast.POSITION.TOP_RIGHT });
			}
		} catch (e) {
			setButtonFlag(false);
			if (e.code === COMMONVARIABLES.STATUS.NETWORK_ERROR_STATUS) {
				toast.error(ERROR.API_ERROR.NETWORK_ERROR, { position: toast.POSITION.TOP_RIGHT });
			} else if (e.code === COMMONVARIABLES.STATUS.BAD_REQUEST_ERROR_STATUS) {
				toast.error(ERROR.API_ERROR.BAD_REQUEST_ERROR, { position: toast.POSITION.TOP_RIGHT });
			} else {
				toast.error(ERROR.API_ERROR.SERVICE_CATCH_ERROR, { position: toast.POSITION.TOP_RIGHT });
			}
		}
	};

	return (
		<>
			<ToastContainer />
			<LoadingOverlay active={isLoading} spinner text="Loading ...">
				<h4 className="card-title">{title}</h4>

				<div className="basic-form overlay">
					<form onSubmit={(e) => e.preventDefault()}>
						{/* Header:
						    Supplier                        Debit Note No *
						    Details                          Debit Date *
						*/}
						<div className="card">
							<div className="card-body">
								<Row className="align-items-start">
									{/* Left: Supplier + Details */}
									<Col lg={7}>
										<div className="row mb-2">
											<div className="form-group text-black font-w500 mb-2 col-lg-2 text-end">
												<label className="col-form-label text-black font-w500">
													Supplier <span className="text-danger">*</span>
												</label>
											</div>
											<div className="form-group text-black font-w300 mb-2 col-lg-3">
												<Select
													value={supplierType}
													onChange={(e) => {
														setSupplierName({});
														onChangeSupplierType(e);
													}}
													options={SUPPLIERTYPE}
													className="my-react-select-container"
													theme={selectTheme}
												/>
											</div>
											<div className="form-group text-black font-w300 mb-2 col-lg-7">
												<Select
													value={supplierName}
													onChange={setSupplierName}
													options={supplierNameOptions.map((option) => ({
														label: option.sm_supplier_name,
														value: option.sm_supplier_code,
														supplier_type: option.supplier_type,
													}))}
													placeholder="Select Supplier"
													className="my-react-select-container"
													theme={selectTheme}
												/>
											</div>
										</div>
										{supplierName?.value ? (
											<div className="row">
												<div className="col-lg-2" />
												<div className="col-lg-10">
													<div className="card-content border border-info pt-2 px-3">
														<address className="text-black mb-2">
															<strong>Supplier Details</strong>
															<br />
															{supplierAddress}
															<br />
															{supplierCity}
															{supplierContact ? (
																<>
																	<br />
																	Contact : {supplierContact}
																</>
															) : null}
															<br />
															<abbr title="GSTIN">GSTIN :{supplierGstin} </abbr>
														</address>
													</div>
												</div>
											</div>
										) : null}
									</Col>

									{/* Right: Debit Note No + Debit Date */}
									<Col lg={5}>
										<div className="row">
											<div className="form-group text-black font-w500 mb-2 mt-1 col-lg-5 text-end">
												<label className="col-form-label text-black font-w500">
													Debit Note No. <span className="text-danger">*</span>
												</label>
											</div>
											<div className="form-group text-black font-w300 mb-2 col-lg-7">
												<input
													type="text"
													className="form-control"
													placeholder="Debit Note No"
													value={debitNoteNo}
													readOnly
												/>
											</div>
											<div className="form-group text-black font-w500 mb-2 mt-1 col-lg-5 text-end">
												<label className="col-form-label text-black font-w500">
													Debit Date <span className="text-danger">*</span>
												</label>
											</div>
											<div className="form-group text-black font-w500 mb-2 col-lg-7">
												<input
													type="date"
													className="form-control"
													value={debitNoteDate}
													onChange={(e) => setDebitNoteDate(e.target.value)}
													max={new Date().toISOString().slice(0, 10)}
												/>
											</div>
										</div>
									</Col>
								</Row>
							</div>
						</div>

						{/* Item entry + table (Purchase style) */}
						<div className="card">
							<div className="card-body px-4 pt-3 py-0">
								<Row>
									<Col lg={12}>
										<div className="row purchase-form align-items-end mb-2">
											<div className="col-lg-4 mb-2">
												<label className="text-black font-w500">
													Item Name <span className="text-danger">*</span>
												</label>
												<Select
													value={currentItem}
													onChange={(value) => {
														setCurrentItem(value);
														const masterItem = itemOptions.find(
															(opt) => opt.im_item_code === value?.value
														);
														if (
															masterItem &&
															(masterItem.im_purchase_rate || masterItem.im_selling_rate) &&
															!currentRate
														) {
															setCurrentRate(
																masterItem.im_purchase_rate ||
																masterItem.im_selling_rate ||
																''
															);
														}
													}}
													options={itemOptions.map((option) => ({
														label: option.im_display_name || option.im_item_name,
														value: option.im_item_code,
													}))}
													placeholder="Select Item"
													className="my-react-select-container"
													theme={selectTheme}
												/>
											</div>
											<div className="col-lg-2 mb-2">
												<label className="text-black font-w500">
													Qty <span className="text-danger">*</span>
												</label>
												<input
													type="number"
													className="form-control text-end"
													placeholder="Qty"
													value={currentQty}
													min="0"
													onKeyPress={(e) => {
														if (e.key === '-' || e.key === 'e') e.preventDefault();
													}}
													onChange={(e) => {
														if (e.target.value <= 9999) {
															setCurrentQty(e.target.value);
														}
													}}
												/>
											</div>
											<div className="col-lg-2 mb-2">
												<label className="text-black font-w500">
													Rate <span className="text-danger">*</span>
												</label>
												<input
													type="number"
													className="form-control text-end"
													placeholder="Rate"
													value={currentRate}
													min="0"
													onKeyPress={(e) => {
														if (e.key === '-' || e.key === 'e') e.preventDefault();
													}}
													onChange={(e) => {
														if (e.target.value <= 999999) {
															setCurrentRate(e.target.value);
														}
													}}
												/>
											</div>
											<div className="col-lg-2 mb-2">
												<label className="text-black font-w500">Amount</label>
												<input
													type="number"
													className="form-control text-end"
													placeholder="Amount"
													readOnly
													value={currentAmount}
												/>
											</div>
											<div className="col-lg-2 mb-2 d-flex align-items-end">
												{isEdit === 0 ? (
													<Button
														onClick={(e) => udfnAddItem(e)}
														className="me-1 btn-icon"
														variant="whatsapp"
													>
														<i className="fa fa-plus" />
													</Button>
												) : (
													<Button
														onClick={(e) => udfnAddItem(e)}
														className="me-1 btn-icon"
														variant="whatsapp"
													>
														<i className="fa fa-check" />
													</Button>
												)}
												<Button
													variant="danger"
													type="button"
													onClick={clearItemValues}
													className="btn btn-success btn-icon"
												>
													<i className="fa fa-ban" />
												</Button>
											</div>
										</div>
									</Col>

									<hr className="mt-1 mb-2 pt-0" />

									<Col xl={12}>
										<div className="row">
											<div className="table-responsive">
												<table className="table table-striped">
													<thead>
														<tr>
															<th width="5%">#</th>
															<th width="35%">Item Name</th>
															<th className="text-end" width="15%">Qty</th>
															<th className="text-end" width="15%">Rate</th>
															<th className="text-end" width="15%">Amount</th>
															<th className="text-center" width="15%">Actions</th>
														</tr>
													</thead>
													<tbody>
														{itemDetails.map((item) => (
															<tr
																key={item.sno}
																style={{
																	backgroundColor:
																		currentSno === item.sno ? '#2df1ff6e' : '',
																}}
															>
																<td>{item.sno}</td>
																<td className="text-black font-w500">{item.item_name}</td>
																<td align="right">{item.qty}</td>
																<td align="right">
																	{Number(item.rate).toLocaleString(undefined, {
																		minimumFractionDigits: 2,
																		maximumFractionDigits: 2,
																	})}
																</td>
																<td align="right">
																	{Number(item.amount).toLocaleString(undefined, {
																		minimumFractionDigits: 2,
																		maximumFractionDigits: 2,
																	})}
																</td>
																<td className="text-center">
																	<Link
																		className="btn btn-secondary shadow btn-xs sharp me-1"
																		onClick={(e) => udfnLoadItem(e, item, 1)}
																	>
																		<i className="fa fa-pencil" />
																	</Link>
																	<Link
																		className="btn btn-danger shadow btn-xs sharp"
																		onClick={() => udfnDeleteItem(item.sno)}
																	>
																		<i className="fa fa-trash" />
																	</Link>
																</td>
															</tr>
														))}
													</tbody>
												</table>
											</div>
										</div>
									</Col>
								</Row>

								<Row className="mb-3 mt-2">
									<Col lg={8} md={12} className="mb-3">
										<label className="text-black font-w300">Narration</label>
										<textarea
											className="form-control"
											rows={5}
											placeholder="Narration"
											value={narration}
											onChange={(e) => setNarration(e.target.value)}
											style={{ height: '120px', minHeight: '120px', resize: 'vertical' }}
										/>
									</Col>
									<Col lg={4} md={12} className="text-end">
										<div className="mb-3 mt-4">
											<label className="text-black font-w500 me-3">Total Amount :</label>
											<strong className="text-black" style={{ fontSize: '1.2rem' }}>
												{COMMONVARIABLES.India_Rupee_Formatter_Digits(totalAmount)}
											</strong>
										</div>
										<div style={{ marginTop: '40px' }}>
											<Link to="/debit-note-list">
												<Button
													variant="danger"
													type="button"
													className="btn btn-success me-2"
												>
													Cancel
												</Button>
											</Link>
											<Button
												variant="secondary"
												type="button"
												className="me-2"
												onClick={udfnResetForm}
											>
												Reset
											</Button>
											<Button
												className="me-2"
												variant="whatsapp"
												ref={buttonRef}
												onClick={onClickSaveBtn}
												disabled={buttonFlag}
											>
												{btnTitle}
											</Button>
										</div>
									</Col>
								</Row>
							</div>
						</div>
					</form>
				</div>

				{/* A5 Debit Note Invoice Print (frontend layout; content from API or sample) */}
				<div style={{ visibility: 'hidden', height: 0 }}>
					<div ref={contentToPrint} className="row purchsecontentToPrint" style={{ padding: '16px' }}>
						<table>
							<style>
								{`
									@page {
										size: A5 portrait;
										padding-left: 8px;
										padding-right: 0px;
									}
								`}
							</style>
							<thead>
								<tr>
									<td>
										<div className="printheader">
											<div className="col-12">
												<div className="row text-center">
													<div className="brand-logo p-16 col-4">
														<img
															className="logo-abbr me-3"
															src={Logo}
															alt=""
															style={{ width: '170px', height: '100px' }}
														/>
													</div>
													<div className="col-8 text-end">
														<span>
															<strong
																style={{ fontSize: 20, fontWeight: 700 }}
																className="d-block text-black"
															>
																{localUserDetails?.company_name}
															</strong>
														</span>
														<small className="text-black" style={{ fontSize: 16, lineHeight: 1.2 }}>
															{localUserDetails?.address}
															{', '}
															{localUserDetails?.city}
															<br />
															{localUserDetails?.state_name}
															<br />
															Email : {localUserDetails?.email_id}
															<br />
															Contact No : {localUserDetails?.mobile_no}
															<strong className="d-block">
																GSTIN : {localUserDetails?.gstin}
															</strong>
														</small>
													</div>
													<div className="h_line" />
													<strong
														style={{ fontSize: 16, fontWeight: 700 }}
														className="d-block text-center text-black"
													>
														DEBIT NOTE
													</strong>
												</div>
												<div className="h_line" />
												<div className="row">
													<div className="col-6">
														<span>
															<strong
																style={{ fontSize: 14, fontWeight: 500, marginBottom: '5px' }}
																className="d-block text-black"
															>
																Supplier :
															</strong>
														</span>
														<small className="text-black" style={{ fontSize: 12, lineHeight: 1.2 }}>
															{printData.supplier_name}
															<br />
															{printData.supplier_address}
															<br />
															{printData.supplier_city}
															{printData.supplier_contact ? (
																<>
																	<br />
																	Contact : {printData.supplier_contact}
																</>
															) : null}
															{printData.supplier_gstin ? (
																<>
																	<br />
																	GSTIN : {printData.supplier_gstin}
																</>
															) : null}
														</small>
													</div>
													<div className="col-6 text-end text-black">
														<table style={{ marginLeft: 'auto', borderCollapse: 'collapse' }}>
															<tbody>
																<tr>
																	<td
																		style={{
																			textAlign: 'right',
																			paddingBottom: '5px',
																			whiteSpace: 'nowrap',
																		}}
																	>
																		Debit Note No.&nbsp;:
																	</td>
																	<td
																		style={{
																			textAlign: 'left',
																			paddingBottom: '5px',
																			paddingLeft: '6px',
																			whiteSpace: 'nowrap',
																		}}
																	>
																		<strong>{printData.debit_note_no}</strong>
																	</td>
																</tr>
																<tr>
																	<td style={{ textAlign: 'right', whiteSpace: 'nowrap' }}>
																		Date&nbsp;:
																	</td>
																	<td
																		style={{
																			textAlign: 'left',
																			paddingLeft: '6px',
																			whiteSpace: 'nowrap',
																		}}
																	>
																		<strong>{printData.debit_note_date}</strong>
																	</td>
																</tr>
															</tbody>
														</table>
													</div>
												</div>
												<div className="h_line" />
											</div>
										</div>
									</td>
								</tr>
							</thead>
							<tbody>
								<tr>
									<td>
										<div className="col-lg-12">
											<div className="table-responsive">
												<table className="table table-striped">
													<thead>
														<tr>
															<th className="center">#</th>
															<th className="center text-black">Item</th>
															<th className="center text-black">Qty</th>
															<th className="text-end text-black">Rate</th>
															<th className="text-end text-black">Amount</th>
														</tr>
													</thead>
													<tbody>
														{printData.item_details?.length > 0
															? printData.item_details.map((row, index) => (
																<tr key={index}>
																	<td className="text-black">{index + 1}</td>
																	<td className="text-black">{row.item_name}</td>
																	<td className="center text-black">{row.quantity}</td>
																	<td className="text-end text-black">
																		{COMMONVARIABLES.India_Rupee_Formatter_Digits(
																			row.rate
																		)}
																	</td>
																	<td className="text-end text-black">
																		{COMMONVARIABLES.India_Rupee_Formatter_Digits(
																			row.amount
																		)}
																	</td>
																</tr>
															))
															: null}
													</tbody>
												</table>
											</div>
											<div className="row mt-2">
												<div className="col-6 text-black">
													Remarks : {printData.narration}
												</div>
												<div className="col-6 text-end text-black">
													<strong>
														Total Amount :{' '}
														{COMMONVARIABLES.India_Rupee_Formatter_Digits(
															printData.total_amount
														)}
													</strong>
												</div>
											</div>
										</div>
									</td>
								</tr>
							</tbody>
							<tfoot>
								<tr>
									<td>
										<div className="footer-space" style={{ padding: 16 }}>
											<div className="printfooter">
												<div className="h_line" />
												<div style={{ marginTop: '35px' }}>
													<div className="row">
														<div className="col-4">
															<strong>Checked by</strong>
														</div>
														<div className="col-4">
															<strong>Verified by</strong>
														</div>
														<div className="col-4 text-end">
															<strong>Authorised Signatory</strong>
														</div>
													</div>
												</div>
											</div>
										</div>
									</td>
								</tr>
							</tfoot>
						</table>
					</div>
				</div>
			</LoadingOverlay>
		</>
	);
};

export default DebitNoteAdd;
